import { Screen } from '~/screens/contract-plans';

export const ContractPlanListIndex: React.FC = () => <Screen />;
